import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { AuthService } from 'angular-security-oauth';
import { KeycloakService } from 'keycloak-angular';

import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { Profile } from '../commons/core/session/session.models';
import { Role } from '../commons/models/role';
import { getLinks, Link } from './links';

@Component({
	selector: 'main-nav',
	templateUrl: './main-nav.component.html',
	styleUrls: ['./main-nav.component.scss']
})
export class MainNavComponent {
	public profile: Profile;
	public links: Link[];

	isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
		.pipe(
			map(result => result.matches),
			shareReplay()
		);

	constructor(
		private breakpointObserver: BreakpointObserver,
		private authServer: AuthService,
		private keycloakService: KeycloakService,

	) {
		const userRoles = this.keycloakService.getUserRoles() as Role[];
		this.links = getLinks(userRoles);
	}

	public logout(): void {
		this.authServer.logout();
	}
}
